import { GlobalService } from '../core/global.service';
import { GlobalNamespace as _GlobalNS } from '../../environments/environment';
import { throwError } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../core/global.service";
var UserRelationshipService = /** @class */ (function () {
    function UserRelationshipService(_http, _global) {
        this._http = _http;
        this._global = _global;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json'
            })
        };
    }
    UserRelationshipService.prototype.find = function () {
        var api = _GlobalNS.api.user.userRelationshipGroup;
        return this._http.get("" + api, {});
    };
    UserRelationshipService.prototype.update = function (userRelationshipGroup) {
        var api = _GlobalNS.api.user.update;
        var eqrf = this._global.find(_GlobalNS.paths.eqrf);
        return this._http.post(api + "&eqrf=" + eqrf, userRelationshipGroup, this.httpOptions);
    };
    /*
    get current person(logged in) details
    */
    UserRelationshipService.prototype.findByPerson = function (operatorOnly) {
        if (operatorOnly === void 0) { operatorOnly = true; }
        var api = _GlobalNS.api.user.userRelationshipGroup;
        var params = new HttpParams().set('OperatorOnly', operatorOnly.toString());
        return this._http.get("" + api, { params: params }).pipe(catchError(function (err) {
            return throwError(err);
        }));
    };
    UserRelationshipService.prototype.displayMoreDialog = function (moreDialog, event, moreDialogDataObj, moreType) {
        var moreData;
        if (moreType === 'ASSETGROUP') {
            moreData = this.assetGroupList(moreDialogDataObj);
        }
        else if (moreType === 'PRIVILEGES') {
            moreData = this.privilegeList(moreDialogDataObj);
        }
        return moreData;
    };
    UserRelationshipService.prototype.assetGroupList = function (relationshipDataGroup) {
        var aData = [];
        if (relationshipDataGroup !== null && relationshipDataGroup !== undefined && relationshipDataGroup.length > 0) {
            for (var i = 0, group = relationshipDataGroup; i < group.length; i++) {
                aData.push(group[i].RelationshipGroupName);
            }
        }
        return aData.join(', ');
    };
    UserRelationshipService.prototype.privilegeList = function (privileges, privilegeGroups, asString) {
        if (asString === void 0) { asString = true; }
        var aData = [];
        var aGroup = [];
        var aGroupPrivilege = [];
        if (privilegeGroups !== null && privilegeGroups !== undefined && privilegeGroups.length > 0) {
            privilegeGroups.filter(function (privileGroupFilter) {
                return (privileGroupFilter.Enabled === undefined || privileGroupFilter.Enabled);
            })
                .map(function (privileGroup) {
                aGroup = [];
                aGroupPrivilege = [];
                privileGroup.Privileges.filter(function (privilegeFilter) { return (privilegeFilter.Enabled === undefined || privilegeFilter.Enabled); })
                    .map(function (privilege) {
                    aGroupPrivilege.push(privilege.PrivilegeName);
                });
                aGroup.push(privileGroup.GroupName + " (" + aGroupPrivilege.join(', ') + ")");
                aData.push(aGroup.join(', '));
            });
        }
        if (privileges !== null && privileges !== undefined && privileges.length > 0) {
            privileges.filter(function (privilegeFilter) { return (privilegeFilter.Enabled === undefined || privilegeFilter.Enabled); })
                .map(function (privilegeMap) { return aData.push(privilegeMap.PrivilegeName); });
        }
        return asString ? aData.join(', ') : aData;
    };
    UserRelationshipService.ngInjectableDef = i0.defineInjectable({ factory: function UserRelationshipService_Factory() { return new UserRelationshipService(i0.inject(i1.HttpClient), i0.inject(i2.GlobalService)); }, token: UserRelationshipService, providedIn: "root" });
    return UserRelationshipService;
}());
export { UserRelationshipService };
